<template>
  <section class="bsp-page-header">
    <AHeader
      :breadcrumbs-items="breadcrumbs"
      :help-button="false"
    >
      <template #custom-buttons>
        <slot name="actions" />
      </template>
    </AHeader>

    <div class="bsp-page-header__content">
      <AIcon
        v-if="icon"
        :icon="icon"
        color="primary"
        size="28"
        with-container
      />

      <div class="bsp-page-header__copy">
        <span v-if="eyebrow" class="bsp-page-header__eyebrow">
          {{ eyebrow }}
        </span>
        <div class="bsp-page-header__title-row">
          <h1>{{ title }}</h1>
          <ATag
            v-if="status"
            :text="status"
            :color="statusColor"
            type="secondary"
          />
        </div>
        <p v-if="description">{{ description }}</p>
        <div v-if="$slots.meta" class="bsp-page-header__meta">
          <slot name="meta" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { AHeader, AIcon, ATag, type ATagColor } from '@adereso-ai/vue-components'
import type { PropType } from 'vue'

interface BspBreadcrumb {
  title: string
  disabled?: boolean
  icon?: string
  to?: {
    name?: string
    path?: string
    query?: Record<string, string | number>
    params?: Record<string, string | number>
  }
}

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  eyebrow: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: ''
  },
  status: {
    type: String,
    default: ''
  },
  statusColor: {
    type: String as PropType<ATagColor>,
    default: 'info'
  },
  breadcrumbs: {
    type: Array as PropType<BspBreadcrumb[]>,
    default: () => []
  }
})
</script>
